import { Form as FactorialForm } from 'factorial-form'
import { computed, makeObservable } from 'mobx'

import { PLANNING_TOOL } from 'modules/time_planning/store/models/PlanningVersion'

class PlanningVersionForm extends FactorialForm {
  constructor(values: object) {
    super(values, {
      id: 'number',
      effective_at: 'string',
      planning_tool: 'string',
      number_of_rest_days_in_cents: 'number',
      schedule_id: 'number',
      employee_id: 'number',
    })

    makeObservable(this, {
      isValid: computed,
      planningTool: computed,
      numberOfRestDays: computed,
      isContractHoursTool: computed,
      isWorkScheduleTool: computed,
      isShiftManagementTool: computed,
    })
  }

  get isValid(): boolean {
    return !this.isWorkScheduleTool || this.get('schedule_id').value
  }

  get planningTool(): string {
    return this.get('planning_tool').value
  }

  get numberOfRestDays(): number {
    return this.get('number_of_rest_days_in_cents').value
  }

  get isContractHoursTool(): boolean {
    return this.planningTool === PLANNING_TOOL.contractHours
  }

  get isWorkScheduleTool(): boolean {
    return this.planningTool === PLANNING_TOOL.workSchedule
  }

  get isShiftManagementTool(): boolean {
    return this.planningTool === PLANNING_TOOL.shiftManagement
  }

  cleanNumberOfRestDaysInCents(): void {
    this.setValues({
      number_of_rest_days_in_cents: null,
    })
  }
}

export default PlanningVersionForm
